<template>
  <div :class="`stepsForWizard${(tamanho ? ('--' + tamanho) : '')}`">
    <div class="bulletsList d-flex align-items-center justify-content-between">
      <div v-for="(val, ind) in passos"
           :key="ind"
           class="bulletsList_box d-inline-block position-relative text-center"
           :class="{ 'bulletsList_box--active': (ativo === ind),
                     'bulletsList_box--complete': (ind < ativo) }">
        <div class="bulletsList_box_shape position-relative">
          {{ ind + ativo }}
        </div>
        <div class="bulletsList_box_content position-absolute text-center">
          {{ val.texto }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'StepsForWizard',
    props: {
      ativo: Number,
      passos: Array,
      tamanho: String
    }
  }
</script>

<style lang="scss">
  @import '../../scss/_utilities/_exports';

  .stepsForWizard {
    margin: 0 auto;
    max-width: pxToRem(568);

    &--xs,
    &--sm,
    &--md,
    &--lg { @extend .stepsForWizard }

    &--xs { max-width: pxToRem(300) }

    &--sm { max-width: pxToRem(568) }

    &--md { max-width: pxToRem(768) }

    &--lg { max-width: pxToRem(768) }
  }

  .bulletsList {
    color: darken($color-gray-light, 12%);

    &_box {
      @include flexItens(null, null, 1 1 auto);

      &_shape {
        border: pxToRem(10) solid darken($color-gray-light, 12%);
        border-radius: 50%;
        color: transparent;
        margin: 0 auto;
        height: pxToRem(38);
        width: pxToRem(38);
      }

      &_content {
        bottom: 0;
        color: inherit;
        font-size: pxToRem(14);
        font-weight: 500;
        left: 0;
        padding: 0 pxToRem(8);
        right: 0;
        top: pxToRem(44);
      }

      &:not(:first-child) {
        &:before {
          background-color: darken($color-gray-light, 12%);
          bottom: 0;
          content: '';
          display: inline-block;
          height: pxToRem(4);
          @include calc(left, '(-100% / 2) + #{pxToRem(30)}', null);
          position: absolute;
          transition: background-color .25s ease-in-out;
          top: pxToRem(16);
          @include calc(width, '100% - #{pxToRem((60))}', null);
          z-index: 2;
        }
      }

      &--active {
        .bulletsList_box_shape {
          border-color: $color-gray;
        }

        .bulletsList_box_content {
          color: $color-gray;
        }
      }

      &--complete {
        .bulletsList_box_shape {
          border-color: $color-light-green;
          background-color: $color-light-green;
          transition: border-color .15s ease-in-out, background-color .15s ease-in-out;

          &:before {
            border: pxToRem(2.5) solid;
            border-color: transparent $color-white $color-white transparent;
            bottom: 0;
            content: '';
            display: inline-block;
            height: pxToRem(18);
            left: 0;
            margin: pxToRem(-4) auto 0;
            @include transform(rotate(40deg));
            position: absolute;
            right: 0;
            top: 0;
            width: pxToRem(12);
          }
        }

        .bulletsList_box_content {
          color: $color-light-green;
        }
      }

      &--complete,
      &--active {
        &:not(:first-child) {
          &:before {
            background-color: $color-light-green;
          }
        }
      }
    }
  }
</style>
